import React, { createContext, Dispatch, ReactNode, SetStateAction, useMemo, useReducer, useState } from "react";
import { SearchData } from "../models/searchData";
import searchDataReducer from "../layout/searchModule/search-module.reducer";

type FilterModuleContextProps = {
    isVisible:boolean,
    setIsVisible:Dispatch<SetStateAction<boolean>>,
    searchData:SearchData,
    dispatchSearchData:React.Dispatch<any>
}

type FilterModuleContextProviderProps = {
    state:boolean;
    children:ReactNode
}

export const FilterModuleContext = createContext<FilterModuleContextProps>({
    isVisible:false,
    setIsVisible: () => void {},
    searchData: new SearchData(),
    dispatchSearchData:() => void {}
});

export const FilterModuleProvider = ({state,children}:FilterModuleContextProviderProps)=>{
    const [searchData, dispatchSearchData] = useReducer<(searchData: SearchData, action: any) => any>(searchDataReducer, new SearchData());
    const [isVisible,setIsVisible] = useState<boolean>(state)
    const value = useMemo(()=>{
        return {isVisible,setIsVisible,searchData,dispatchSearchData}
    },[isVisible,searchData])
    return(
        <FilterModuleContext.Provider value={value}>
            {children}
        </FilterModuleContext.Provider>
    )
}

